var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCategory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 44"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.19 2.5a7.73 7.73 0 1 0 7.73 7.73 7.74 7.74 0 0 0-7.73-7.73zm0 12.46a4.73 4.73 0 1 1 4.73-4.73A4.73 4.73 0 0 1 10.19 15zM10.19 24.27A7.73 7.73 0 1 0 17.92 32a7.74 7.74 0 0 0-7.73-7.73zm0 12.46A4.73 4.73 0 1 1 14.92 32a4.73 4.73 0 0 1-4.73 4.73zM10.19 46a7.73 7.73 0 1 0 7.73 7.73A7.74 7.74 0 0 0 10.19 46zm0 12.46a4.73 4.73 0 1 1 4.73-4.73 4.73 4.73 0 0 1-4.73 4.77zM29.92 14.84h27a4.62 4.62 0 1 0 0-9.23h-27a4.62 4.62 0 0 0 0 9.23zm0-6.23h27a1.62 1.62 0 1 1 0 3.23h-27a1.62 1.62 0 0 1 0-3.23zM56.92 27.38h-27a4.62 4.62 0 0 0 0 9.24h27a4.62 4.62 0 0 0 0-9.24zm0 6.24h-27a1.62 1.62 0 0 1 0-3.24h27a1.62 1.62 0 0 1 0 3.24zM56.92 49.15h-27a4.62 4.62 0 0 0 0 9.23h27a4.62 4.62 0 1 0 0-9.23zm0 6.23h-27a1.62 1.62 0 0 1 0-3.23h27a1.62 1.62 0 1 1 0 3.23z",
    fill: "#000000",
    opacity: 1,
    "data-original": "#000000",
    className: ""
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCategory);
export default __webpack_public_path__ + "static/media/category.3dd12e36033c87ab6c294ea743e83dd1.svg";
export { ForwardRef as ReactComponent };